export const homePageRouter = [
  {
    path: `/HomePage`,
    name: `HomePage`,
    redirect: `/main`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/main',
        name: 'HomePage',
        meta: {
          activename: 'HomePage'
        },
        component: () => import('@/views/homePage/HomePage')
      }
    ]
  }
];
